let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("6qah4"), load("c6MKV"), load("25CqL")]).then(() => parcelRequire('6mTAL'));